import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
import _imports_0 from '@/img/secure.png';
const _hoisted_1 = {
    key: 0,
    class: "text-center"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
    key: 3,
    class: "text-center mt-3"
};
const _hoisted_4 = { class: "cardContainer" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { ref: "cardelement" };
const _hoisted_7 = {
    ref: "carderrors",
    class: "mt-2 text-danger",
    role: "alert"
};
const _hoisted_8 = { class: "form-group mt-3" };
const _hoisted_9 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_stripe_saved_cards = _resolveComponent("stripe-saved-cards");
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.cards && _ctx.cards.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "fs-14 mt-1 mb-2" }, "Seleziona una carta salvata", -1)),
                (_ctx.cards.length > 0)
                    ? (_openBlock(), _createBlock(_component_stripe_saved_cards, {
                        key: 0,
                        cards: _ctx.cards,
                        modelValue: _ctx.selectedCard,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCard) = $event))
                    }, null, 8, ["cards", "modelValue"]))
                    : _createCommentVNode("", true),
                (_ctx.paying)
                    ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 1 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (_ctx.selectedCard)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-green fs-22",
                                    disabled: !!!_ctx.selectedCard,
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.pay && _ctx.pay(...args)))
                                }, "Paga", 8, _hoisted_2)
                            ]))
                            : _createCommentVNode("", true)
                    ], 64)),
                (!_ctx.paying)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", null, "Oppure", -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-blue",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.setShowNewCard && _ctx.setShowNewCard(...args)))
                        }, "Usa un'altra carta")
                    ]))
                    : _createCommentVNode("", true)
            ], 64))
            : _createCommentVNode("", true),
        (_ctx.cards && _ctx.cards.length == 0 || _ctx.showNewCard && !!!_ctx.selectedCard)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "paymentForm",
                ref: "paymentform",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.pay && _ctx.pay(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "cardholder",
                            placeholder: "Intestatario carta",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.cardholderName) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.cardholderName]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_6, null, 512),
                    _createElementVNode("div", _hoisted_7, null, 512)
                ]),
                (_ctx.paying)
                    ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_8, [
                            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Salva carta per i pagamenti futuri", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "form-control ml-2",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.saveCard) = $event))
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.saveCard]
                            ])
                        ]),
                        _createElementVNode("button", {
                            ref: "submit",
                            type: "submit",
                            class: "btn btn-green fs-22",
                            disabled: !_ctx.canPay
                        }, "Paga", 8, _hoisted_9)
                    ], 64))
            ], 544))
            : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createElementVNode("img", {
            width: "300",
            class: "mt-5",
            src: _imports_0
        }, null, -1))
    ]));
}
